import { Icon } from "@/Assets/Icons";
import classNames from "classnames";
import TimeAgo from 'react-timeago';
import { EApprovalStatusType, ENotificationType } from "@/Redux/Ducks/inboxSlice";
import BaseMethods from "AlignBaseUI/BaseMethods";
import { MdMailOutline, MdRefresh, MdMarkEmailUnread, MdOutlineDelete, MdOutlineStar, MdOutlineCheckCircleOutline, MdNotifications, MdOutlineNotificationImportant, MdInfoOutline, MdSend, MdOutbox, MdSearch, MdChevronLeft } from 'react-icons/md';
import { constant } from "@/Utils/constants";
import { Button, Col, Container, Row } from "react-bootstrap";
import { ControlTranslation } from "AlignComponents";

export const AlignUIRender = ({ activeSideMenu, changeRoute }: any) => {
	return (
		<div className="menu">
			<div className={classNames(["menu-item", { active: activeSideMenu.isEqual("/approval", "/approval/active") }])} onClick={() => changeRoute("approval")}>
				<div dangerouslySetInnerHTML={{ __html: Icon.Inbox }} />
				<ControlTranslation system={true} controlId="lblapprovals" />
			</div>
			<div className={classNames(["menu-item", { active: activeSideMenu == "/notification" }])} onClick={() => changeRoute("notification")}>
				<div dangerouslySetInnerHTML={{ __html: Icon.Notifications }} />
				<ControlTranslation system={true} controlId="lblnotifications" />
			</div>
			<div className={classNames(["menu-item", { active: activeSideMenu.isEqual("/outbox", "/outbox/approval", "/outbox/notification") }])} onClick={() => changeRoute("outbox")}>
				<div dangerouslySetInnerHTML={{ __html: Icon.SentForApproval }} />
				<ControlTranslation system={true} controlId="lbloutbox" />
			</div>
			<div className={classNames(["menu-item", { active: activeSideMenu == "/important" }])} onClick={() => changeRoute("important")}>
				<div dangerouslySetInnerHTML={{ __html: Icon.Important }} />
				<ControlTranslation system={true} controlId="lblimportant" />
			</div>
			<div className={classNames(["menu-item", { active: activeSideMenu == "/trash" }])} onClick={() => changeRoute("trash")}>
				<div dangerouslySetInnerHTML={{ __html: Icon.Trash }} />
				<ControlTranslation system={true} controlId="lbltrash" />
			</div>
		</div>
	)
}